<style scoped lang="css">
.grid_tool {
  display: grid;
  grid-template-columns: 20px 20px 20px;
  grid-template-rows: 20px 20px 20px;
}

.grid_tool_icon {
  display: inline-grid;
  vertical-align: middle;
  grid-template-columns: 6px 6px 6px;
  grid-template-rows: 6px 6px 6px;
}

.grid_tool_icon .grid_tool_item {
  height: 5px !important;
}

.grid_tool_item {
  border: 0.5px solid white;
  color: white;
  line-height: 20px;
  cursor: pointer;
  margin: 0.5px;
  background: transparent;
}
.grid_tool_item__active {
  background-color: var(--brandPrimary);
}
</style>
<template>
  <a-popover :title="false">
    <template slot="content">
      <div class="p-all">
        {{ isMPR ? $t("Disable MPR First") : $t("Layouts") }}
      </div>
    </template>

    <a-popover
      overlayClassName="grid_overlay"
      :trigger="isMPR ? 'contextmenu' : 'click'"
    >
      <template slot="content">
        <div class="grid_tool p-all" @mouseout="currentIndex = undefined">
          <div
            v-for="index in 9"
            :key="index"
            @mouseover="
              mouseover = true;
              currentIndex = index;
            "
            class="grid_tool_item"
            @click="currentGridsChange(selectedGrids)"
            v-bind:class="{
              grid_tool_item__active:
                (currentIndex && selectedGrids.grids.indexOf(index) !== -1) ||
                (!currentIndex && currentGrids.grids.indexOf(index) !== -1),
            }"
          >
            <!-- {{ index }} -->
          </div>
        </div>
      </template>

      <span
        class="tool-group-btn without-arrow"
        v-bind:class="{
          'tool-group-btn__active': currentGrids.grids.length > 1,
          'tool-group-btn__disabled': isMPR,
        }"
      >
        <span class="tool-group-btn__item tool-group-btn__icon">
          <div class="grid_tool grid_tool_icon">
            <div
              v-for="index in 9"
              :key="index"
              class="grid_tool_item"
              v-bind:class="{
                grid_tool_item__active:
                  currentGrids.grids.indexOf(index) !== -1,
              }"
            >
              <!-- {{ index }} -->
            </div>
          </div>
        </span>
      </span>
    </a-popover>
  </a-popover>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      currentIndex: undefined,
    };
  },
  computed: {
    ...mapGetters(["currentGrids", "isMPR"]),
    selectedGrids() {
      let selectedGrids = [];
      let gridInfo = {};
      switch (this.currentIndex) {
        case 1:
          selectedGrids = [1];
          gridInfo = {
            row: 1,
            col: 1,
          };
          break;
        case 2:
          selectedGrids = [1, 2];
          gridInfo = {
            row: 1,
            col: 2,
          };
          break;
        case 3:
          selectedGrids = [1, 2, 3];
          gridInfo = {
            row: 1,
            col: 3,
          };
          break;
        case 4:
          selectedGrids = [1, 4];
          gridInfo = {
            row: 2,
            col: 1,
          };
          break;
        case 5:
          selectedGrids = [1, 2, 4, 5];
          gridInfo = {
            row: 2,
            col: 2,
          };
          break;
        case 6:
          selectedGrids = [1, 2, 3, 4, 5, 6];
          gridInfo = {
            row: 2,
            col: 3,
          };
          break;
        case 7:
          selectedGrids = [1, 4, 7];
          gridInfo = {
            row: 3,
            col: 1,
          };
          break;
        case 8:
          selectedGrids = [1, 2, 4, 5, 7, 8];
          gridInfo = {
            row: 3,
            col: 2,
          };
          break;
        case 9:
          selectedGrids = [1, 2, 3, 4, 5, 6, 7, 8, 9];
          gridInfo = {
            row: 3,
            col: 3,
          };
          break;
      }

      return {
        grids: selectedGrids,
        info: gridInfo,
      };
    },
  },
  created() {
    this.$accessModule("grid_tool", this);
  },
  methods: {
    currentGridsChange(grids) {
      this.$store.dispatch(
        "updateGrid",
        grids.length > 0 &&
          grids[grids.length - 1] ==
            this.currentGrids[this.currentGrids.length - 1]
          ? []
          : grids
      );
      this.$debug(
        "Изменены настройки вьюпортов. текущие: ",
        "success",
        this.currentGrids
      );
    },
  },
};
</script>
